import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const Wrapper = styled.div`
  inline-size: 100%;
`;

export const Box = styled.div`
  inline-size: 100%;

  border: 1px solid #dfdfdf;
  border-radius: 12px;

  background-color: #ffffff;

  overflow: hidden;
`;

type FieldBoxProps = {
  $isOpen: boolean;
};

const FieldBox = styled.button<FieldBoxProps>`
  display: flex;
  gap: 8px;
  align-items: center;

  inline-size: 100%;
  padding: 12px;

  border: none;

  cursor: pointer;

  &:hover {
    background-color: #ffffff;
  }
`;

export const FieldBoxActive = styled(FieldBox)`
  background-color: #556bb4;

  &:hover {
    background-color: #556bb4;
  }
`;

export const FieldBoxInactive = styled(FieldBox)`
  background-color: #ffffff;

  &:hover {
    background-color: #d6dced;
  }
`;

const FieldIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;

  svg {
    inline-size: 20px;
    block-size: 20px;
  }
`;

export const FieldIconActive = styled(FieldIcon)`
  color: #ffffff;
`;

export const FieldIconInactive = styled(FieldIcon)`
  color: #788ac4;
`;

const FieldText = styled.span`
  flex: 1 0 0;

  min-inline-size: 0;

  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  white-space: nowrap;
  text-align: start;
  text-overflow: ellipsis;

  overflow: hidden;
`;

export const FieldTextActive = styled(FieldText)`
  color: #ffffff;
  font-weight: 700;
`;

export const FieldTextInactive = styled(FieldText)`
  color: #2c4692;
  font-weight: 400;
`;

export const ClearButton = styled.span`
  display: inline-flex;
  flex-shrink: 0;

  color: #ffffff;

  cursor: pointer;

  svg {
    inline-size: 16px;
    block-size: 16px;
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  max-block-size: 280px;
  padding-block-end: 12px;
  padding-inline: 12px;

  overflow-y: auto;
`;

export const MenuDivider = styled.div`
  flex-shrink: 0;

  block-size: 1px;
  margin-block-end: 2px;

  background-color: #dfdfdf;
`;

type MenuItemProps = {
  $isAll: boolean;
  $isZero: boolean;
};

export const MenuItem = styled.div<MenuItemProps>`
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  align-items: center;

  min-block-size: 26px;
  padding-inline: 4px;

  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;

  cursor: pointer;

  &:hover {
    background-color: #d6dced;
  }

  span {
    color: ${props => {
      if (props.$isAll) return "#2c4692";
      if (props.$isZero) return "#888888";
      return "#000000";
    }};
  }

  em {
    color: #888888;
    font-style: normal;
  }
`;
